import * as i18next from 'i18next'
import { Range } from 'immutable'
import React, { ReactNode } from 'react'
import { ItemWithDates, DateStateUpdaters } from './date.state'

export const DateLayout = {
  ItemList : (props: {
    items: ItemWithDates[],
    text: string,
    updateText: (text: string) => void,
    saveAndReload: () => void,
    saveDisabled: boolean
  }): JSX.Element => (
    <div>
      <div>
        {props.items.map(item => (
          <div key={item.id}>
            <div>
              Id: {item.id} 
            </div>
            <div>
              CreatedDate: {item.createdDate.toLocaleString()}
            </div>
            <div>
              ModifiedDate: {item.modifiedDate.toLocaleString()}
            </div>
            <div>
              Content: {item.dateTest.toLocaleString()}
            </div>
          </div>
        ))}
      </div>
      <div>
        <input
          value={props.text}
          onChange={e => props.updateText(e.currentTarget.value)}
        >       
        </input>
      </div>    
      <div>
        <button
          onClick={_ => {
            console.log("Clicked!")
            props.saveAndReload()
            }
          }
          disabled={props.saveDisabled}
        >
          Save
        </button>
      </div>
    </div>
  )
}